import styled, { css } from 'styled-components';
import { acceptgreen, defaultsearchcolor, divider, grey, warningred } from 'styles/Colors';

export const RosterPlayerName = styled.p`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 250px;
  margin-bottom: 0;
`;

export const PullRight = styled.div<{ size: 'sm' | 'lg' }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 70%;
  gap: 16px;

  .foreign-id {
    margin-bottom: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: right;

    ${(props) =>
      props.size === 'sm' &&
      css`
        @media (min-width: 576px) {
          width: 75px;
        }
        @media (min-width: 768px) {
          width: 100px;
        }
        @media (min-width: 992px) {
          width: 150px;
        }
        @media (min-width: 1200px) {
          width: 150px;
        }
      `}
  }
`;

export const ForeignId = styled.p`
  color: ${grey};
`;

export const RosterPlayerWrapper = styled.div`
  height: 48px;
  width: 100%;
  line-height: 48px;
  padding: 0 3px;
  border-bottom: 1px solid ${divider};
  display: flex;
  align-items: center;

  &.in-lineup {
    p {
      color: ${grey};
    }
  }

  &:last-of-type {
    border: none;
  }

  svg {
    display: inline;
    cursor: pointer;
  }
  .plus-icon {
    g {
      path {
        fill: ${acceptgreen};
      }
    }
  }
  .minus-icon {
    g {
      path {
        fill: ${warningred};
      }
    }
  }
`;

export const EntryNumber = styled.span`
  width: 30px;
  float: left;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  color: ${grey};
  line-height: 12px;
`;
